<template>
    <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Activate your account</h2>
          <p>We've sent a verification code to your email address.</p> 
          <p>Please enter your email and the verification code below to verify your account.</p>
        </v-layout>

                    <v-alert :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
                    
                    <v-layout justify-center column>
                        <v-form ref="form" v-model="valid" @submit="confirm">

                            <v-text-field outline v-model="username" :rules="usernameRules" label="Email" type="email"  required ></v-text-field>

                            <v-text-field outline v-model="code" :rules="codeRules" label="Confirmation code" required ></v-text-field>
                            
                            <v-layout row align-center mx-1>
                              <router-link to="/send-confirm-code" class="text-button">Need a new verification code?</router-link>
                              <v-spacer />
                              <v-btn :disabled="!valid" type="submit"  class="button" >Submit Verification Code</v-btn>
                            </v-layout>
                        </v-form>
    
                   </v-layout>
               </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: 'Login',
  data () {
    
    return {
      valid: true,
      codeRules: [
        v => !!v || 'Confirmation code must be enetered',
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid'
      ],
      username: '',
      code: '',
      error: null,
      loading: false
    }
  },
  methods: {
    confirm (e) {
      e.preventDefault()
        this.loading = true
        var email = this.username
        var confCode = this.code

        this.$confirmRegistration(email, confCode).subscribe((data) => {

            if (typeof window.android !== 'undefined') { 
              window.android.onRegistrationConfirmed() 
            }
            if (typeof window.webkit !== 'undefined') { 
              
              window.webkit.messageHandlers.iOS.postMessage('registrationConfirmed')
            }

            console.log('cofirm success');
            this.$router.push("/login?code=true");
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            if(err.code === "UnknownError"){
                this.$router.push("/login-set-password");
            }
            console.log(err.message);
            this.error = err;
        });

        /*this.$store.dispatch('confirmRegistration', {email: email, verificationCode: confCode}).then(() => {
            console.log("login successful");
            this.$router.push("/login");
        })
        .catch((err) => {
            console.log(err.message);
            this.error = err;
            
        }); */    
    }
  }
}
</script>

<style scoped>
</style>